import { FloatingTooltip } from '../../../Floating'
import { Skeleton } from '../../../Skeleton'
import Text from '../../../Text'
import { BIRDVIEW_TILE_UNAVAILABLE_COUNT } from '../../DashboardBirdview.constants'
import { formatBirdviewNumber } from '../../DashboardBirdview.utils.charts'
import {
  checkIsBirdviewErrorState,
  checkIsBirdviewLoadingState,
} from '../../DashboardBirdview.utils.sections'

import * as styles from './DashboardTileValue.module.css'

function DashboardTileValue({ count, state, tooltip }) {
  return checkIsBirdviewLoadingState(state) ? (
    <Skeleton className={styles.countSkeleton} />
  ) : (
    <FloatingTooltip content={tooltip} disabled={!tooltip}>
      <Text className={styles.count}>
        {checkIsBirdviewErrorState(state)
          ? BIRDVIEW_TILE_UNAVAILABLE_COUNT
          : formatBirdviewNumber(count)}
      </Text>
    </FloatingTooltip>
  )
}

export default DashboardTileValue
